import { gql } from '@apollo/client';

export interface StaffLeaveCarpoolTripMutation {
  staffLeaveCarpoolTrip: {
    id: string;
  };
}

export interface StaffLeaveCarpoolTripMutationVariables {
  tripId: string;
  userId: string;
}

export const STAFF_LEAVE_CARPOOL_TRIP = gql`
  mutation StaffLeaveCarpoolTrip($tripId: ID!, $userId: ID!) {
    staffLeaveCarpoolTrip(tripId: $tripId, userId: $userId) {
      id
    }
  }
`;
